module.exports = __webpack_public_path__ + "img/pr-3.fa012d19.png";